export default __webpack_public_path__ + "static/media/gallery_05.7212aaa4.jpg";